export default "__VITE_ASSET__7f524c4d__"